module.exports = __webpack_public_path__ + "resources/label_big_group_owner.df3e0f20220c4f44.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/label/img/label_big_group_owner.png
// module id = 563
// module chunks = 0 1 2 3